import {Pipe, PipeTransform} from '@angular/core';
import firebase from 'firebase';
import Timestamp = firebase.firestore.Timestamp;
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'timestamp'
})
export class TimestampPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {
  }

  /**
   *
   * @param value
   * @param {...any} args
   */
  transform(value: Timestamp | Date | undefined, ...args: string[]) {
    if (value instanceof Timestamp) {
      const date = value.toDate();
      return this.datePipe.transform(date, args[0]);
    } else if (value instanceof Date) {
      return this.datePipe.transform(value, args[0]);
    }
    return null;
  }
}
